export default __webpack_public_path__ + "static/leather-7c5720aac1ff1cd830dc9405985516d3.jpg";